/*
  Author: Vaishnavi
  Date: 18/11/2019
  Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari,
  Spacing fixes done.
*/

/*
Author: Vinod
Date: 04/12//2019
Issue_id JIRA: PL-1980
Issue Description: When added the data and clicked on Skip, should throw an error message that data is not saved.
search_string: UAT_60
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: ext button should be replaced with save.
search_string: PL_2030
*/

/*
Author: Vinod
Date: 21/01//2019
Issue Description: IT- Income Tax Proof Submission Mode should also include Both.
search_string: PL_2465
*/

<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="itDeclarations">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <tl-accordion headerName="IT Declaration (Plan) Settings" :active="true">
        <template v-slot:accordionBody>
          <div class="row" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12 margin-b-s">
              <span class="label">Income Tax Calculation Method</span>
            </div>
            <div class="col-3">
              <tl-select
                label="Select Regime *"
                name="Select Regime"
                :options="['Old Regime', 'New Regime', 'Old and New Regime Both']"
                v-model="incomeTaxModel.declarationSettings.declaration_regime_option"
                @change="(val) => incomeTaxModel.declarationSettings.declaration_regime_option = val"
                v-validate="{required: true}"
                :classname="errors.has('Select Regime')"
                :errormsg="errors.first('Select Regime')"
              />
            </div>
            <div class="col-12 margin-b-s">
            <div class="row margin-t-l">
              <span>By Default regime selection would be locked for employees after selection, enable below options, as applicable, for regime change feature at ESS end </span>
            </div>
            </div>
            <div class="col-12 margin-t-15px">
              <tl-checkbox
                label="Allow ‘Old Regime’ to ‘New Regime’ change"
                @change="(val)=>incomeTaxModel.declarationSettings.declaration_allow_old_to_new_regime = val"
                :checked="incomeTaxModel.declarationSettings.declaration_allow_old_to_new_regime"
              ></tl-checkbox>
            </div>
            <div class="col-12 margin-t-15px">
              <tl-checkbox
                label="Allow ‘New Regime’ to ‘Old Regime’ change"
                @change="(val)=>incomeTaxModel.declarationSettings.declaration_allow_new_to_old_regime = val"
                :checked="incomeTaxModel.declarationSettings.declaration_allow_new_to_old_regime"
              ></tl-checkbox>
            </div>
          </div>
          <div class="row margin-t-l" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12 margin-b-s">
              <span class="label">Declaration Period (Every Month)</span>
            </div>
            <div class="col-3">
              <tl-select
                label="Start Month *"
                name="Start Month"
                :options="['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']"
                v-model="incomeTaxModel.declarationSettings.declarationStartMonth"
                @change="(val) => incomeTaxModel.declarationSettings.declarationStartMonth = val"
                data-vv-as="start month"
                v-validate="{required: true}"
                :classname="errors.has('Start Month')"
                :errormsg="errors.first('Start Month')"
              />
            </div>
            <div class="col-3">
              <tl-select
                label="From *"
                name="From"
                :options="Array.from(Array(31).keys(), val=>val+1)"
                v-model="incomeTaxModel.declarationSettings.declarationStartDate"
                @change="(val)=>{getDaysList(incomeTaxModel.declarationSettings.declarationStartDate = val, incomeTaxModel.declarationSettings.declarationEndDate, 'declairation'); incomeTaxModel.declarationSettings.declarationEndDate=null}"
                data-vv-as="from"
                v-validate="{required: true}"
                :classname="errors.has('From')"
                :errormsg="errors.first('From')"
              />
            </div>
            <div class="col-3">
              <tl-select
                label="To *"
                name="To"
                :options="Array.from(Array(31-incomeTaxModel.declarationSettings.declarationStartDate).keys(), val=>incomeTaxModel.declarationSettings.declarationStartDate+val+1)"
                v-model="incomeTaxModel.declarationSettings.declarationEndDate"
                @change="(val)=>getDaysList(incomeTaxModel.declarationSettings.declarationStartDate, incomeTaxModel.declarationSettings.declarationEndDate = val, 'declairation')"
                data-vv-as="to"
                v-validate="{required: true}"
                :classname="errors.has('To')"
                :errormsg="errors.first('To')"
              />
            </div>
          </div>
          <div class="row margin-t-l" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12">
              <span class="label">Reminder Settings</span>
            </div>
            <div class="col-12 margin-t-m">
              <tl-radio
                label="Periodically"
                name="reminderSettings"
                v-model="incomeTaxModel.declarationSettings.declarationReminderDateOption"
                value="EVERYDAY"
                id="periodically"
                data-vv-as="IT Declaration Reminder Settings"
                ref="reminderSettingsVal"
              />
            </div>
            <div class="col-12 margin-t-15px">
              <tl-radio
                label="On Specific Dates"
                name="reminderSettings"
                v-model="incomeTaxModel.declarationSettings.declarationReminderDateOption"
                @change="getDaysList(incomeTaxModel.declarationSettings.declarationStartDate, incomeTaxModel.declarationSettings.declarationEndDate, 'declairation')"
                value="SELECTED_DAYS"
                id="specific"
                data-vv-as="IT Declaration Reminder Settings"
                ref="reminderSettingsVal"
              />
            </div>
            <div
              class="col-12 margin-t-m"
              v-if="incomeTaxModel.declarationSettings.declarationReminderDateOption == 'SELECTED_DAYS'"
            >
              <ul class="days-box">
                <li
                  :class="{'selected': day.selected}"
                  v-for="(day,index) in monthDays"
                  :key="index"
                  :value="day.day"
                  @click="weekOffDays(index)"
                >{{day.day}}</li>
              </ul>
            </div>
            <div
              class="col-12 margin-t-m"
              v-if="incomeTaxModel.declarationSettings.declarationReminderDateOption != 'SELECTED_DAYS'"
            >
              <tl-select
                label="Start Date *"
                name="declarationReminderStartDate"
                labelText="day"
                v-model="incomeTaxModel.declarationSettings.declarationReminderStartDate"
                :options="monthDays"
                @change="(val)=>incomeTaxModel.declarationSettings.declarationReminderStartDate = val.day"
                data-vv-as="start date"
                v-validate="'required_if:reminderSettingsVal,EVERYDAY'"
                :classname="errors.has('declarationReminderStartDate')"
                :errormsg="errors.first('declarationReminderStartDate')"
              />
            </div>
          </div>
          <div
            class="row"
            v-if="incomeTaxModel.declarationSettings.declarationReminderDateOption != 'SELECTED_DAYS'"
             :disabled="!(ifTeamleaderPermission)"
          >
            <div class="col-12 margin-t-m">
              <span class="label">Reminder Frequency</span>
            </div>
            <div class="col-12 margin-t-m">
              <tl-radio
                label="Everyday from  Reminder start date to Declaration End Date"
                name="startDate"
                v-model="incomeTaxModel.declarationSettings.declarationReminderFrequency"
                value="EVERYDAY"
                id="startDate"
              />
            </div>
            <div class="col-12 margin-t-15px">
              <tl-radio
                label="Every alternate day from Reminder start date to Declaration End Date"
                name="startDate"
                v-model="incomeTaxModel.declarationSettings.declarationReminderFrequency"
                value="EVERY_ALTERNATE_DAY"
                id="altDate"
              />
            </div>
          </div>
          <div class="row margin-t-m" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12">
              <tl-select
                label="Send Reminder To *"
                labelText="name"
                name="Send Reminder"
                v-model="incomeTaxModel.declarationSettings.declarationReminderAllEmployees"
                :options="reminderToOptions"
                @change="(val)=>incomeTaxModel.declarationSettings.declarationReminderAllEmployees = val"
                data-vv-as="send reminder to"
                v-validate="{required: true}"
                :classname="errors.has('Send Reminder')"
                :errormsg="errors.first('Send Reminder')"
              />
            </div>
              <div class="col-12">
                <div class="row margin-t-m">
                   <div class="margin-t-m">
                      <span>Send Reminder On : </span>
                   </div>
                <tl-select
                class="select"
                labelText="name"
                name="hr:"
                :options="hourOption"
                v-model="incomeTaxModel.declarationSettings.send_on_hr"
                @change="(val)=>incomeTaxModel.declarationSettings.send_on_hr = val"
              />
              <div class="margin-t-m">
                      <span>  Hours</span>
                   </div>
                              <tl-select
                class="select"
                labelText="name"
                name="min:"
                :options="minutesOption"
               v-model="incomeTaxModel.declarationSettings.send_on_min"
                @change="(val)=>incomeTaxModel.declarationSettings.send_on_min = val"
              />
              <div class="margin-t-m">
                      <span>Minutes</span>
                   </div>
                </div>
              </div>
          <div class="row margin-t-m">

                  <div class="margin-t-m">
                     <div class="template">
                       <span>Reminder For Declaration Email Template</span>
                        <div class="templateData">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                       </div>
                  </div>
                 </div>

                    <div class="margin-t-m marginleft-32">
                    <div class="template">
                      <span>Declaration Window Opened Email Template</span>
                        <div class="templateData ">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                        </div>
                   </div>
                  </div>

                  <div class="margin-t-m marginleft-32">
                    <div class="template">
                      <span>Declaration Window Closed Email Template</span>
                        <div class="templateData ">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                        </div>
                   </div>
                  </div>

            </div>


            <!-- <div class="col-12 margin-t-l">
              <tl-checkbox
                label="Carry forward IT Proof as declaration for next financial year"
                @change="(val)=>incomeTaxModel.declarationSettings.itDeclarationOfEmployeesToNextYear = val"
                :checked="incomeTaxModel.declarationSettings.itDeclarationOfEmployeesToNextYear"
              ></tl-checkbox>
            </div> -->
            <div class="col-12 margin-t-l">
              <tl-checkbox
                label="Allow Future Declaration"
                @change="(val)=>incomeTaxModel.declarationSettings.allowFutureDeclaration = val"
                :checked="incomeTaxModel.declarationSettings.allowFutureDeclaration"
              ></tl-checkbox>
            </div>
          </div>
        </template>
      </tl-accordion>
      <tl-accordion class="margin-t-25px" headerName="IT Proof Submission Settings">
        <template v-slot:accordionBody>
          <div class="row margin-t-xs" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12 margin-b-m">
              <span class="label">Submission Period</span>
            </div>
            <div class="col-3">
              <span class="input-label">From *</span>
              <date-picker
                name="Submission Period From"
                :value="incomeTaxModel.submissionSettings.submissionStartDate"
                :dates-disabled="{from: new Date(incomeTaxModel.submissionSettings.submissionEndDate)}"
                @datevalue="(val)=>{incomeTaxModel.submissionSettings.submissionStartDate =val;changeReminderSetting();}"
                data-vv-as="from"
                v-validate="{required: true}"
                :classname="errors.has('Submission Period From')"
                :errormsg="errors.first('Submission Period From')"
              />
            </div>
            <div class="col-3">
              <span class="input-label">To *</span>
              <date-picker
                name="Submission Period To"
                :value="incomeTaxModel.submissionSettings.submissionEndDate"
                :dates-disabled="{to: new Date(incomeTaxModel.submissionSettings.submissionStartDate)}"
                @datevalue="(val)=>{incomeTaxModel.submissionSettings.submissionEndDate = val;changeReminderSetting()}"
                data-vv-as="to"
                v-validate="{required: true}"
                :classname="errors.has('Submission Period To')"
                :errormsg="errors.first('Submission Period To')"
              />
            </div>
            <div class="col-12 margin-t-m">
              <tl-select
                name="Mode of Proof Submission"
                label="Mode of Proof Submission *"
                labelText="name"
                v-model="incomeTaxModel.submissionSettings.submissionModeOfProof"
                :options="modeOfSubmission"
                @change="(val)=>incomeTaxModel.submissionSettings.submissionModeOfProof = val"
                data-vv-as="mode of proof submission"
                v-validate="{required: true}"
                :classname="errors.has('Mode of Proof Submission')"
                :errormsg="errors.first('Mode of Proof Submission')"
              />
              
            </div>
            <div class="col-6 margin-t-m">
              <tl-checkbox
                style="margin-bottom:30px;"
                class="headcheck"
                name="releaseITProof"
                label="Enable IT Proof for Employees"
                v-show="incomeTaxModel.submissionSettings.submissionStartDate && incomeTaxModel.submissionSettings.submissionEndDate"
                v-model="incomeTaxModel.submissionSettings.releaseITProof"
              />
              <tl-checkbox
              style="margin-bottom:30px;"
                class="headcheck"
                name="enableSection10"
                label="Enable Section 10 for Employees"
                v-show="incomeTaxModel.submissionSettings.submissionStartDate && incomeTaxModel.submissionSettings.submissionEndDate"
                v-model="incomeTaxModel.submissionSettings.enableSection10"
              />
              <tl-checkbox
                class="headcheck"
                name="enable_regime_change"
                label="Enable Regime change option for Employees"
                v-show="incomeTaxModel.submissionSettings.submissionStartDate && incomeTaxModel.submissionSettings.submissionEndDate"
                v-model="incomeTaxModel.submissionSettings.enable_regime_change"
              /> 
            </div>
            
            
          </div>
          <div   class="row margin-t-m" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12">
              <span class="label">Income Tax Proof Submission Employee Wise</span>
            </div>
            <div class="download-btn">
           
              <div class="download-btn-container">
                <img src="@/assets/download.svg"  class="img" />
                <span class="text"  @click="downloadUrl"">Download Template</span>
                <loading-animation v-show="showLoader"></loading-animation>
            </div>
           
            <div class="margin-t-15px">
              <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
          </div>
          </div>
          <div class="row margin-t-m" :disabled="!(ifTeamleaderPermission)">     
            <div class="col-12">
              <span class="label">Reminder Settings</span>
            </div>
            <div class="col-12 margin-t-m">
              <tl-radio
                label="Periodically"
                name="submissionReminderSettings"
                v-model="incomeTaxModel.submissionSettings.submissionReminderDateOption"
                value="EVERYDAY"
                id="subperiodically"
                data-vv-as="IT Proof Submission Reminder Settings"
                ref="itProofSubmissionReminderSettingsVal"
              />
            </div>
            <div class="col-12 margin-t-15px">
              <tl-radio
                label="On Specific Dates"
                name="submissionReminderSettings"
                v-model="incomeTaxModel.submissionSettings.submissionReminderDateOption"
                value="SELECTED_DAYS"
                id="subspecific"
                data-vv-as="IT Proof Submission Reminder Settings"
                ref="itProofSubmissionReminderSettingsVal"
              />
            </div>
            <div
              class="col-12 margin-t-m"
              v-if="incomeTaxModel.submissionSettings.submissionReminderDateOption == 'SELECTED_DAYS'"
            >
              <ul class="days-box">
                <li
                  :class="{'selected': day.selected}"
                  v-for="(day,index) in monthDaysProof"
                  :key="index"
                  :value="day.day"
                  @click="weekOffDaysProof(index)"
                >{{day.day}}</li>
              </ul>
            </div>
            <div
              class="col-12 margin-t-m"
              v-show="incomeTaxModel.submissionSettings.submissionReminderDateOption != 'SELECTED_DAYS'"
            >
              <tl-select
                label="Start Date *"
                name="submissionReminderStartDate"
                v-model="incomeTaxModel.submissionSettings.submissionReminderStartDate"
                :options="submissionRemiderDates"
                @change="(val)=>incomeTaxModel.submissionSettings.submissionReminderStartDate = val"
                data-vv-as="start date"
                v-validate="'required_if:itProofSubmissionReminderSettingsVal,EVERYDAY'"
                :classname="errors.has('submissionReminderStartDate')"
                :errormsg="errors.first('submissionReminderStartDate')"
              />
            </div>
          </div>
          <div
            class="row margin-t-m"
            v-if="incomeTaxModel.submissionSettings.submissionReminderDateOption != 'SELECTED_DAYS'"
            :disabled="!(ifTeamleaderPermission)"
          >
            <div class="col-12 margin-t-xs">
              <span class="label">Reminder Frequency</span>
            </div>
            <div class="col-12 margin-t-s">
              <tl-radio
                label="Everyday from  Reminder start date to Declaration End Date "
                name="subStartDate"
                v-model="incomeTaxModel.submissionSettings.submissionReminderFrequency"
                value="EVERYDAY"
                id="startSubDate"
              />
            </div>
            <div class="col-12 margin-t-s">
              <tl-radio
                label="Every alternate day from Reminder start date to Declaration End Date"
                name="subStartDate"
                v-model="incomeTaxModel.submissionSettings.submissionReminderFrequency"
                value="EVERY_ALTERNATE_DAY"
                id="altSubDate"
              />
            </div>
          </div>
          <div class="row margin-t-s" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12 margin-t-m">
              <tl-select
                label="Send Reminder To *"
                labelText="name"
                name="IT Proof Submission Send Reminder To"
                v-model="incomeTaxModel.submissionSettings.submissionReminderAllEmployees"
                :options="subReminderToOptions"
                @change="(val)=>incomeTaxModel.submissionSettings.submissionReminderAllEmployees = val"
                data-vv-as="send reminder to"
                v-validate="{required: true}"
                :classname="errors.has('IT Proof Submission Send Reminder To')"
                :errormsg="errors.first('IT Proof Submission Send Reminder To')"
              />
            </div>
          </div>
          <div class="col-12">
                <div class="row margin-t-m" :disabled="!(ifTeamleaderPermission)">
                   <div class="margin-t-m">
                      <span>Send Reminder On : </span>
                   </div>
                <tl-select
                class="select"
                labelText="name"
                name="hr:"
                :options="hourOption"
                v-model="incomeTaxModel.submissionSettings.send_on_hr"
                @change="(val)=>incomeTaxModel.submissionSettings.send_on_hr = val"
                             />
              <div class="margin-t-m">
                      <span>  Hours</span>
                   </div>
                              <tl-select
                class="select"
                labelText="name"
                name="min:"
                :options="minutesOption"
                 v-model="incomeTaxModel.submissionSettings.send_on_min"
                @change="(val)=>incomeTaxModel.submissionSettings.send_on_min = val"
              />
              <div class="margin-t-m">
                      <span>Minutes</span>
                   </div>
                </div>
              </div>
                      <div class="row margin-t-m" :disabled="!(ifTeamleaderPermission)">

                  <div class="margin-t-m">
                     <div class="template">
                       <span>Reminder For Proof Submission Email Template</span>
                        <div class="templateData">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                       </div>
                  </div>
                 </div>

                    <div class="margin-t-m marginleft-32">
                    <div class="template">
                      <span>Proof Submission Window Opened Email Template</span>
                        <div class="templateData ">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                        </div>
                   </div>
                  </div>

                  <div class="margin-t-m marginleft-32">
                    <div class="template">
                      <span>Proof Submission Window Closed Email Template</span>
                        <div class="templateData ">
                          <button>
                            <img src="@/assets/edit.png" alt>
                          </button>
                        </div>
                   </div>
                  </div>

            </div>
        </template>
      </tl-accordion>
      <tl-accordion headerName="IT Deduction">
        <template v-slot:accordionBody>
          <div class="row" :disabled="!(ifTeamleaderPermission)">
            <div class="col-12">
              <tl-checkbox
                label="Exempt Employee for IT Deduction for 1st month"
                @change="(val) => incomeTaxModel.itSettings.exemptForITDeductionFirstMonth = val"
                :checked="incomeTaxModel.itSettings.exemptForITDeductionFirstMonth"
              ></tl-checkbox>
              <div class="belowText">
                <span
                  class="input-label"
                >If employee is joining in the last month of financial year, Income Tax will be deducted.</span>
              </div>
            </div>
            <div class="col-12 margin-t-m">
              <tl-checkbox
                label="Enable employee to declare other income"
                @change="(val) => incomeTaxModel.itSettings.declareOtherIncome = val"
                :checked="incomeTaxModel.itSettings.declareOtherIncome"
              ></tl-checkbox>
            </div>
            <div class="col-12 margin-t-m">
              <!-- label="Apply flat 22.5% tax on employees without PAN" previous -->
              <tl-checkbox
                label="Apply flat tax based on slab for employees without PAN"
                @change="(val) => incomeTaxModel.itSettings.applyWithoutPan = val"
                :checked="incomeTaxModel.itSettings.applyWithoutPan"
              ></tl-checkbox>
            </div>
          </div>
        </template>
      </tl-accordion>
    </div>
    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <!-- Start UAT_60 -->
    <pop-up-message
      v-if="showWarningPopup"
      message="On skip, your made changes won't be saved!"
      popupType="Warning"
      :popupHeaderMessage="'Warning'"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="skip()">Skip</button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <!-- End UAT_60 -->
    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="skip()"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <!-- Start PL_2030 -->
          <btn text="Next" type="primary" @click="submitITData" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
          <!-- End PL_2030 -->
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { selectMixin } from "@/mixins/selectMixin";
import { mapActions, mapState, mapGetters } from "vuex";
import { api_variables } from "@/apis/variables.js";
export default {
  mixins: [selectMixin],
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_IT_PROOF_EMPLOYEE_WISE_UPLOAD,
      hourOption:Array.from(Array(23), (x, index) => index + 1),
      minutesOption:Array.from(Array(60), (x, index) => index),
      showSuccessMsg: false,
      showWarningPopup: false, // UAT_60
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      reminderToOptions: [
        { id: "UNDECLARED", name: "Employees who have not Declared Tax" },
        { id: "ALL", name: "All Employees" }
      ],
      modeOfSubmission: [
        // { id: "HARD", name: "Hard Copy" },
        { id: "SOFT", name: "Soft Copy" },
        // { id: "BOTH", name: "Both" } // PL_2465
      ],

      subReminderToOptions: [
        { id: "NOT_SUBMITTED", name: "Employees who have not submitted proof" },
        { id: "ALL", name: "All Employees" }
      ],
      selectedWeekOffDays: [],
      selectedWeekOffDaysProof: [],
      submissionRemiderDates: [],
      monthDays: [],
      monthDaysProof: [],
      errmsg: "",
      toast: false,
      incomeTaxModel: {
        le_id: "",
        type: "POST",
        declarationSettings: {
          declarationStartDate: "",
          declarationEndDate: "",
          declarationStartMonth: "",
          declarationReminderStartDate: "",
          declarationReminderFrequency: "EVERYDAY",
          declarationReminderDateOption: "EVERYDAY",
          declarationValue: [],
          declarationReminderAllEmployees: "",
          itDeclarationOfEmployeesToNextYear: false,
          allowFutureDeclaration:false,
          declaration_regime_option : "",
          declaration_allow_old_to_new_regime:false,
          declaration_allow_new_to_old_regime:false,
          send_on_hr:"",
          send_on_min:""

        },
        submissionSettings: {
          submissionStartDate: "",
          submissionEndDate: "",
          submissionModeOfProof: "",
          submissionReminderStartDate: "",
          submissionReminderFrequency: "EVERYDAY",
          submissionReminderDateOption: "EVERYDAY",
          submissionValue: [],
          submissionReminderAllEmployees: "",
          send_on_hr:"",
          send_on_min:""
        },
        itSettings: {
          exemptForITDeductionFirstMonth: false,
          applyWithoutPan: false,
          declareOtherIncome: false
        }
      },
      statutorySettingsValue: false,
      role: "",
      email:"",
      showLoader: false,
    };
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState("onboard/statutoryinfo/incometax", {
      incomeTaxData: state => state.data
    }),

    leId() {
      if (this.$route.params.entity_index) {
        console.log("this.getLegalEntityId(this.$route.params.entity_index)",this.getLegalEntityId(this.$route.params.entity_index));
        return this.getLegalEntityId(this.$route.params.entity_index)
        ;
      } else {
        console.log("this.getLegalEntityId(0)",this.getLegalEntityId(0));
        return this.getLegalEntityId(0);    
      }
    },

    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },

    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.statutorySettingsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }
      
      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.statutorySettingsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }

    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },

  mounted() {
    this.calculateMonthDaysProof();
    this.setIncomeTaxData(this.incomeTaxData[this.leId]);
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions("onboard/statutoryinfo/incometax/", {
      act_create: "create",
      act_fetchAll: "fetchAll"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      employeeWiseDownload: "dashboard/itProof/employeeWiseDownload",
      employeeWiseUpload:"dashboard/itProof/employeeWiseUpload",
    }),
    // Start UAT_60
    cancelEvent() {
      this.showWarningPopup = false;
    },
    skip() {
      this.showWarningPopup = false;
      this.$emit("skip");
    },
    back() {
      this.toast = false;
      this.showSuccessBulkUploadMsg = false;
    },
    // End UAT_60

    /** Function to set form data from server */
    setIncomeTaxData(Obj) {
      try {

        if (Object.keys(Obj).length) {
          console.log("im here");
          this.incomeTaxModel.declarationSettings.declaration_regime_option =
            Obj.declarationSettings.declaration_regime_option;
          this.incomeTaxModel.declarationSettings.declarationStartMonth =
            Obj.declarationSettings.declarationStartMonth;
          this.incomeTaxModel.declarationSettings.declarationStartDate =
            Obj.declarationSettings.declarationStartDate;
          this.incomeTaxModel.declarationSettings.declarationEndDate =
            Obj.declarationSettings.declarationEndDate;
          this.getDaysList(
            Obj.declarationSettings.declarationStartDate,
            Obj.declarationSettings.declarationEndDate,
            "declairation"
          );
          this.incomeTaxModel.declarationSettings.declarationReminderDateOption =
            Obj.declarationSettings.declarationReminderDateOption;
          this.incomeTaxModel.declarationSettings.declarationReminderStartDate =
            Obj.declarationSettings.declarationReminderStartDate;
          this.incomeTaxModel.declarationSettings.declarationValue =
            Obj.declarationSettings.declarationValue;
          if (Obj.declarationSettings.declarationValue.length) {
            this.monthDays.forEach(element => {
              element.selected = Obj.declarationSettings.declarationValue.some(
                item => item == element.day
              );
            });
          }

          this.incomeTaxModel.declarationSettings.declarationReminderFrequency =
            Obj.declarationSettings.declarationReminderFrequency;

          this.incomeTaxModel.declarationSettings.declarationReminderAllEmployees =
            Obj.declarationSettings.declarationReminderAllEmployees;
            this.incomeTaxModel.declarationSettings.send_on_hr =
            Obj.declarationSettings.send_on_hr;
            this.incomeTaxModel.declarationSettings.send_on_min =
            Obj.declarationSettings.send_on_min;
          this.incomeTaxModel.declarationSettings.itDeclarationOfEmployeesToNextYear =
            Obj.declarationSettings.itDeclarationOfEmployeesToNextYear;
            this.incomeTaxModel.declarationSettings.allowFutureDeclaration =
            Obj.declarationSettings.allowFutureDeclaration;
            this.incomeTaxModel.declarationSettings.declaration_allow_old_to_new_regime =
            Obj.declarationSettings.declaration_allow_old_to_new_regime;
            this.incomeTaxModel.declarationSettings.declaration_allow_new_to_old_regime =
            Obj.declarationSettings.declaration_allow_new_to_old_regime;
          // submission data settings
          this.incomeTaxModel.submissionSettings.submissionStartDate =
            Obj.submissionSettings.submissionStartDate;
          this.incomeTaxModel.submissionSettings.submissionEndDate =
            Obj.submissionSettings.submissionEndDate;
          this.calculateMonthDaysProof();
          this.incomeTaxModel.submissionSettings.submissionModeOfProof =
            Obj.submissionSettings.submissionModeOfProof;
            console.log("im also here",this.incomeTaxModel.submissionSettings.releaseITProof)
          if (Obj.submissionSettings.releaseITProof) {
            this.incomeTaxModel.submissionSettings.releaseITProof = Obj.submissionSettings.releaseITProof
            console.log( this.incomeTaxModel.submissionSettings.releaseITProof)
          } else {
               this.incomeTaxModel.submissionSettings.releaseITProof=false
            }
            if (Obj.submissionSettings.enableSection10) {
            this.incomeTaxModel.submissionSettings.enableSection10 = Obj.submissionSettings.enableSection10
          } else {
               this.incomeTaxModel.submissionSettings.enableSection10=false
            }
            // Obj.submissionSettings.enable_regime_change = false
            if(this.incomeTaxData[this.leId].submissionSettings.enable_regime_change){
              this.incomeTaxModel.submissionSettings.enable_regime_change = true
            }else if(this.incomeTaxData[this.leId].submissionSettings.enable_regime_change = null){
              this.incomeTaxModel.submissionSettings.enable_regime_change = false
            } else{
              this.incomeTaxModel.submissionSettings.enable_regime_change = false
            }
           
          this.incomeTaxModel.submissionSettings.submissionReminderDateOption =
            Obj.submissionSettings.submissionReminderDateOption;
          this.incomeTaxModel.submissionSettings.submissionReminderFrequency =
            Obj.submissionSettings.submissionReminderFrequency;
          this.changeReminderSetting();
          setTimeout(() => {
            this.incomeTaxModel.submissionSettings.submissionReminderStartDate =
              Obj.submissionSettings.submissionReminderStartDate;
          }, 1000);
          this.incomeTaxModel.submissionSettings.submissionValue =
            Obj.submissionSettings.submissionValue;
          if (Obj.submissionSettings.submissionValue.length) {
            this.monthDaysProof.forEach(element => {
              element.selected = Obj.submissionSettings.submissionValue.some(
                item => item == element.day
              );
            });
          }

          this.incomeTaxModel.submissionSettings.submissionReminderAllEmployees =
            Obj.submissionSettings.submissionReminderAllEmployees;
          this.incomeTaxModel.itSettings.exemptForITDeductionFirstMonth =
            Obj.itSettings.exemptForITDeductionFirstMonth;
          this.incomeTaxModel.itSettings.applyWithoutPan =
            Obj.itSettings.applyWithoutPan;
          this.incomeTaxModel.itSettings.declareOtherIncome =
            Obj.itSettings.declareOtherIncome;
            this.incomeTaxModel.submissionSettings.send_on_hr =
            Obj.submissionSettings.send_on_hr;
            this.incomeTaxModel.submissionSettings.send_on_min =
            Obj.submissionSettings.send_on_min;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async downloadUrl() {
      try {
        this.showLoader = true
        let res = await this.employeeWiseDownload({
            le_id:this.leId
          });
          if (res.data.status) {
            this.showLoader = false
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "IT Proof Approval"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
       
      } catch (e) {
        this.showLoader = false
        this.toast = true;
        this.errmsg = e;
      }
    },
    async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},
async onUploadTemplate(event) {
      try {
        let formData = new FormData();
          formData.append("file", event);
          formData.append("le_id", this.leId);
          formData.append(
            "loggedInUser", this.email
          );
         
        let res = await this.employeeWiseUpload(formData);
        
        if (res.statusCode==200) {
          this.responseMsg = res.message ? res.message : "";
          this.showSuccessBulkUploadMsg = true;
        }
        else{
          this.showSuccessBulkUploadMsg = false;
          this.toast = true;
          this.errmsg = res.message ? res.message : "";
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to validate from */
    async submitITData() {
      if(this.ifAnchor) {
          this.nextPage();
        } else {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
      }
    },

    /* server call to submit form data */
    async performAction() {
      try {

        this.incomeTaxModel.le_id = this.leId;
        if (
          this.incomeTaxModel.declarationSettings
            .declarationReminderDateOption == "EVERYDAY"
        ) {
          this.incomeTaxModel.declarationSettings.declarationValue = [];
          this.incomeTaxModel.declarationSettings.declaration_regime_option;
        } else {
          this.incomeTaxModel.declarationSettings.declarationReminderStartDate = null;
        }
        if (
          this.incomeTaxModel.submissionSettings.submissionReminderDateOption ==
          "EVERYDAY"
        ) {
          this.incomeTaxModel.submissionSettings.submissionValue = [];
          this.incomeTaxModel.declarationSettings.declaration_regime_option;
        } else {
          this.incomeTaxModel.submissionSettings.submissionReminderStartDate = null;
        }
        let declairationVal = this.incomeTaxModel.declarationSettings
          .declarationValue;
        if (
          !declairationVal.length &&
          this.incomeTaxModel.declarationSettings
            .declarationReminderDateOption == "SELECTED_DAYS"
        ) {
          this.errmsg =
            "Please select IT Declaration (Plan) Settings - Reminder Settings - On Specific Dates";
          this.toast = true;
          return;
        }

        let submissionVal = this.incomeTaxModel.submissionSettings
          .submissionValue;
        if (
          !submissionVal.length &&
          this.incomeTaxModel.submissionSettings.submissionReminderDateOption ==
            "SELECTED_DAYS"
        ) {
          this.errmsg =
            "Please selecty IT Proof Submission Settings - Reminder Settings - On Specific Dates";
          this.toast = true;
          return;
        }

        this.errmsg = "";
        this.toast = false;

        this.$root._data.isSaving = true;
        let res = await this.act_create({
          data: {
            ...this.incomeTaxModel
          }
        });
        setTimeout(() => {
          if (res.data.status) {
            this.responseMsg = "IT Settings " + res.data.message;
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to hide success message */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },

    /* function to set reminder start and end dates */
    changeReminderSetting() {
      try {
        this.submissionRemiderDates = [];
        this.incomeTaxModel.submissionSettings.submissionReminderStartDate = null;
        let date1 = new Date(
          this.incomeTaxModel.submissionSettings.submissionStartDate
        );
        let date2 = new Date(
          this.incomeTaxModel.submissionSettings.submissionEndDate
        );
        if (date1.getMonth() == date2.getMonth()) {
          for (let i = date1.getDate(); i <= date2.getDate(); i++) {
            this.submissionRemiderDates.push(i);
          }
        } else {
          for (let i = 1; i <= 31; i++) {
            this.submissionRemiderDates.push(i);
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get the list of dates after selecting declaration start and end dates  */
    getDaysList(val1, val2, type) {
      try {
        this.incomeTaxModel.declarationSettings.declarationReminderStartDate = null;
        if (val1 && val2) {
          let count = val1;
          let daysList = [];
          while (count <= val2) {
            daysList.push({
              day: count,
              selected: false
            });
            count++;
          }
          if (type == "declairation") {
            this.monthDays = daysList;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   /* function to get the list of dates after selecting submission start and end dates  */
    calculateMonthDaysProof() {
      try {
        this.monthDaysProof = [];
        let obj = {};
        for (var i = 1; i <= 31; i++) {
          let obj = {};
          obj.day = i;
          obj.selected = false;
          this.monthDaysProof.push(obj);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* function to select dates(In declaration section) after selecting as 'on specific dates' */
    weekOffDays(idx) {
      try {
        this.monthDays[idx].selected = !this.monthDays[idx].selected;
        if (this.incomeTaxModel.declarationSettings.declarationValue.length) {
          if (
            !this.incomeTaxModel.declarationSettings.declarationValue.some(
              item => item == this.monthDays[idx].day
            )
          ) {
            this.incomeTaxModel.declarationSettings.declarationValue.push(
              this.monthDays[idx].day
            );
          } else {
            let index = this.incomeTaxModel.declarationSettings.declarationValue.findIndex(
              item => item == this.monthDays[idx].day
            );
            if (index > -1) {
              this.incomeTaxModel.declarationSettings.declarationValue.splice(
                index,
                1
              );
            }
          }
        } else {
          this.incomeTaxModel.declarationSettings.declarationValue.push(
            this.monthDays[idx].day
          );
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to select dates(in submission section) after selecting as 'on specific dates' */
    weekOffDaysProof(idx) {
      try {
        this.monthDaysProof[idx].selected = !this.monthDaysProof[idx].selected;
        if (this.incomeTaxModel.submissionSettings.submissionValue.length) {
          if (
            !this.incomeTaxModel.submissionSettings.submissionValue.some(
              item => item == this.monthDaysProof[idx].day
            )
          ) {
            this.incomeTaxModel.submissionSettings.submissionValue.push(
              this.monthDaysProof[idx].day
            );
          } else {
            let index = this.incomeTaxModel.submissionSettings.submissionValue.findIndex(
              item => item == this.monthDaysProof[idx].day
            );
            if (index > -1) {
              this.incomeTaxModel.submissionSettings.submissionValue.splice(
                index,
                1
              );
            }
          }
        } else {
          this.incomeTaxModel.submissionSettings.submissionValue.push(
            this.monthDaysProof[idx].day
          );
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("skip");
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.email = data.data.user.email
      this.statutorySettingsValue = data.data.user.permissions.statutory_settings ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "../../../../../../scss/variables";
.label {
  color: #444444;
  font-size: 14px;
  font-weight: 600;
  font-family: Montserrat;
}
.select {

  width: 80px;
  margin-left: 10px;
  margin-right: 10px;
}
.template {
  width: 259px;
  height: 76px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(88, 81, 81, 0.16);
  background-color: #f5f5f5;
}
.templateData{
  padding-top: -30px;
  margin: 0px 0px 0px 235px;
}

.belowText {
  margin-left: 3.5%;
}
.bg-grey {
  background-color: #e4e4e4;
  padding: 10px;
}
ul {
  padding-left: 0px;
  margin-left: 24px;
}
.days-box {
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    display: inline-block;
    font-weight: 500;
    width: 50px;
    margin-bottom: 3px;
    padding: 15px 20px;
    cursor: pointer;
    &:hover,
    &.selected {
      background-color: #34c0be;
      color: #ffffff;
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.download-btn-container {
  margin-top: 15px;
  display: flex;
  align-items: normal;
  margin-bottom:-40px;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}
</style>
